import React from 'react'
import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Theme/Common'
import type { FollowMeProfile } from '@core/Areas/FollowMe/types'
import {
  navigateToProfileFollowersList,
  navigateToProfileFollowingList,
} from '@core/Areas/FollowMe/helpers/navigation'

export const FollowStats: React.FC<
  Pick<FollowMeProfile, 'followerCount' | 'followingCount' | 'shareCount' | 'id'>
> = ({ followerCount, followingCount, shareCount, id }) => {
  return (
    <WrapperStyled>
      <div onClick={() => navigateToProfileFollowersList(id)}>
        <span>{followerCount || 0}</span>
        <span>Followers</span>
      </div>

      <div onClick={() => navigateToProfileFollowingList(id)}>
        <span>{followingCount}</span>
        <span>Following</span>
      </div>

      <div>
        <span>{shareCount}</span>
        <span>Shared Bets</span>
      </div>
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  margin: '0 auto',
  fontFamily: font.family.primary,
  textAlign: 'center',

  '> div': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `0 ${spacing.sm}`,

    '&:nth-of-type(2)': {
      borderRight: `1px solid ${colors.neutral[200]}`,
      borderLeft: `1px solid ${colors.neutral[200]}`,
    },

    '> span:first-of-type': {
      fontSize: font.size.xl2.fontSize,
      letterSpacing: font.size.xl2.letterSpacing,
      lineHeight: font.size.xl2.lineHeight,
      fontWeight: font.weight.semibold,
      color: colors.black,
    },

    '> span:last-of-type': {
      fontSize: font.size.md.fontSize,
      letterSpacing: font.size.md.letterSpacing,
      lineHeight: font.size.md.lineHeight,
      fontWeight: font.weight.regular,
      color: colors.neutral[700],
    },
  },
})
